import React from 'react';
import ReactDOM from 'react-dom/client';
import { preparePwaNavigation } from './v2/pwa/prepaint';

if (process.env.REACT_APP_UI === 'v2') preparePwaNavigation();

const loadUI = process.env.REACT_APP_UI === 'v2'
  ? () => import(/* webpackChunkName: "v2-app" */ './v2/V2App')
  : () => import(/* webpackChunkName: "legacy-app" */ './App');
const UI = React.lazy(loadUI);

// iOS Safari's `100vh` includes the collapsible toolbar area, which leaves the
// layout too tall (content hidden behind the URL bar). Expose the *real*
// viewport height as a `--vh` custom property that the layout uses instead.
const setViewportHeight = () => {
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`
  );
};
setViewportHeight();
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div role="status" aria-busy="true" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui, sans-serif' }}>Loading Aman Mail…</div>}>
      <UI />
    </React.Suspense>
  </React.StrictMode>
);
